import { api, ApiError, ApiRequest } from '~/components/Providers/APIClient';
import { notFound } from '@tanstack/react-router';

export const apiQueryFn =
    <T = unknown>({ ...request }: ApiRequest) =>
    async (): Promise<T> => {
        const response = await api.send(request);
        if (response.error) {
            if (response.status === 404) throw notFound();
            throw new ApiError(
                response.data.message,
                response.status,
                response.data,
                response.networkError,
            );
        }
        return response.data as T;
    };
